import React, { useContext, useEffect, useState } from "react";
import OpenInformationRequest from "../organisms/OpenInformationRequest";
import * as Endpoint from "../../Http";
import EnterDebtorNumber from "../organisms/EnterDebtorNumber";
import { UserContext } from "../Context/UserContext";
import { useParams } from "react-router";
import useApiCall from "../Hooks/useApiCall";
import * as Routes from "../../Routes";
const LoginContainer = ({ history, }) => {
    const { employer_number, form_code, dossier_number } = useParams();
    const { setUser } = useContext(UserContext);
    const [credentials, setCredentials] = useState({
        dossier_number: dossier_number || "",
        form_code: form_code || "",
        employer_number: employer_number || "",
    });
    const [showDebtorForm, setShowDebtorForm] = useState(false);
    const [login, errors, clearErrors, loading] = useApiCall("post", Endpoint.LOGIN, credentials);
    useEffect(() => {
        if (window.location.pathname !== Routes.LOGIN) {
            attemptLogin();
        }
    }, []);
    const handleChange = (e) => {
        setCredentials(Object.assign(Object.assign({}, credentials), { [e.currentTarget.name]: e.currentTarget.value }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        attemptLogin();
    };
    const attemptLogin = () => {
        login()
            .then((res) => {
            setUser(res.data);
            history.push("/");
        })
            .catch((err) => {
            const responseErrors = err.fieldErrors;
            if (responseErrors.debtor_number &&
                responseErrors.debtor_number[0].includes("meerdere debiteuren")) {
                openDebtorNumberWindow();
            }
        });
    };
    const openDebtorNumberWindow = () => {
        clearErrors();
        setCredentials(Object.assign(Object.assign({}, credentials), { debtor_number: "" }));
        setShowDebtorForm(true);
    };
    const closeDebtorNumber = () => {
        setShowDebtorForm(false);
        clearErrors();
        const credentialsClone = Object.assign({}, credentials);
        delete credentialsClone.debtor_number;
        setCredentials(credentialsClone);
    };
    return !showDebtorForm ? (React.createElement(OpenInformationRequest, { loading: loading, errors: errors, credentials: credentials, onSubmit: handleSubmit, onChange: handleChange })) : (React.createElement(EnterDebtorNumber, { onBackward: closeDebtorNumber, loading: loading, errors: errors, credentials: credentials, onSubmit: handleSubmit, onChange: handleChange }));
};
export default LoginContainer;
